import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import projectStyles from '../../../common/global-styles/idatacoding.module.less'
import collegeManagerStyles from '../../../college-oam/college-oam.module.less'
import {
  message,
  Button,
  Col,
  ConfigProvider,
  Layout,
  Pagination,
  Popconfirm,
  Row,
  Statistic,
  Table,
  Tooltip,
  Select,
  Input,
} from 'antd'
import {
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  LoadingOutlined,
} from '@ant-design/icons'
import zhCN from 'antd/lib/locale/zh_CN'
import commitStyle from './commit-record.module.less'
import StatusCard from '../../../../component/status-card/status-card'
import TooltipModal from '../../../../component/modal/stop-task-modal/TooltipModal'
import BatchTooltipModal from '../../../../component/modal/stop-task-modal/BatchTooltipModal'
import DateRangePicker from '../../../../component/date-range-picker/DateRangePicker'
import './stoping.css'
const commitData = [
  {
    commit_id: 1,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'running',
    process: '50',
  },
  {
    commit_id: 2,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'running',
    process: '50',
  },
  {
    commit_id: 4,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'running',
    process: '50',
  },
  {
    commit_id: 9,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'running',
    process: '50',
  },
  {
    commit_id: 8,
    task_id: '6',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 1,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'success',
    process: '50',
  },
  {
    commit_id: 7,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 1,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'failed',
    process: '50',
  },
  {
    commit_id: 6,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 1,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'stoped',
    process: '50',
  },
  {
    commit_id: 5,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'queueing',
    process: '50',
  },
  {
    commit_id: 10,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'stoping',
    process: '50',
  },
  {
    commit_id: 12,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'stoping',
    process: '50',
  },
]
const { Search } = Input
const { Option } = Select
export interface Props {}

const selecOptions = [
  {
    label: '全部班级',
    value: 'all',
  },
  {
    label: '22-大数据',
    value: '22-大数据',
  },
  {
    label: '22-大数据',
    value: '21-大数据',
  },
]
export interface Props {
  mode: string
}
const CommitRecord: React.FC<Props> = (props) => {
  const { mode } = props
  const useStyle =
    mode === 'oam'
      ? projectStyles
      : mode === 'college-oam'
      ? collegeManagerStyles
      : ''
  const page = useRef(1)
  const pageSize = useRef(10)
  const [tooltipopen, setTooltipopen] = useState(false)
  const [seleOptions, setSeleOptions] = useState(selecOptions)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [open, setOpen] = useState(false)
  const statusCard = useRef([
    {
      type: 'running',
      label: '运行中',
      num: 30,
    },
    {
      type: 'success',
      label: '成功',
      num: 30,
    },
    {
      type: 'failed',
      label: '失败',
      num: 30,
    },
    {
      type: 'stoped',
      label: '已停止',
      num: 30,
    },
    {
      type: 'queueing',
      label: '排队中',
      num: 30,
    },
  ])
  const history = useHistory()
  const stopTask = (index) => {
    setTooltipopen(true)
  }

  const renderStatus = (text: any, record: any, index: any) =>
    text === 'running' ? (
      <>
        <SyncOutlined style={{ color: '#3C85FF', marginRight: '5px' }} spin />
        运行中
      </>
    ) : text === 'success' ? (
      <>
        <CheckCircleOutlined style={{ color: '#00D1A3', marginRight: '5px' }} />
        成功
      </>
    ) : text === 'failed' ? (
      <>
        <CloseCircleOutlined style={{ color: '#FE650F', marginRight: '5px' }} />
        失败
      </>
    ) : text === 'stoped' ? (
      <>
        <StopOutlined style={{ color: '#F5A722', marginRight: '5px' }} />
        已停止
      </>
    ) : text === 'queueing' ? (
      <>
        <ClockCircleOutlined style={{ color: '#9F6AF5', marginRight: '5px' }} />
        排队中
      </>
    ) : text === 'stoping' ? (
      <>
        <div>
          <div className="spin spin-spinning" style={{ marginRight: 5 }}>
            <span className="spin-dot spin-dot-spin">
              <i className="spin-dot-item"></i>
              <i className="spin-dot-item"></i>
              <i className="spin-dot-item"></i>
              <i className="spin-dot-item"></i>
              <i className="spin-dot-item"></i>
              <i className="spin-dot-item"></i>
              <i className="spin-dot-item"></i>
              <i className="spin-dot-item"></i>
            </span>
          </div>
          正在停止
        </div>
      </>
    ) : (
      ''
    )

  const renderAction = (text: any, record: any, index: number) =>
    record.status === 'running' ? (
      <Row align={'middle'} justify={'center'}>
        <Col style={{ marginRight: 10 }}>
          <Tooltip placement="top" title={'查看'}>
            <div className="info-icon">
              <i className="iconfont icon-chakan" style={{ fontSize: 17 }}></i>
            </div>
          </Tooltip>
        </Col>
        <Col>
          <Tooltip placement="top" title={'停止'}>
            <div className="stoped-icon" onClick={(index) => stopTask(index)}>
              <i className="iconfont icon-zhongzhi"></i>
            </div>
          </Tooltip>
        </Col>
      </Row>
    ) : record.status !== 'running' ? (
      <Row align={'middle'} justify={'center'}>
        <Col style={{ marginRight: 10 }}>
          <Tooltip placement="top" title={'查看'}>
            <div className="info-icon">
              <i className="iconfont icon-chakan" style={{ fontSize: 17 }}></i>
            </div>
          </Tooltip>
        </Col>
        <Col>
          <div className="stoped-icon-disabled">
            <i className="iconfont icon-zhongzhi"></i>
          </div>
        </Col>
      </Row>
    ) : (
      ''
    )

  const gotoCommitDetail = () => {
    if (mode == 'oam') history.push('/oam_commit_detail')
    if (mode == 'college-oam') history.push(`/college-oam/commit_detail`)
  }

  const commitCols: any =
    mode === 'oam'
      ? [
          {
            title: '提交ID',
            dataIndex: 'commit_id',
            key: 'commit_id',
            align: 'center',
            width: 70,
          },
          {
            title: '任务ID',
            dataIndex: 'task_id',
            key: 'task_id',
            ellipsis: false,
            align: 'center',
            width: 70,
          },
          {
            title: '任务编号',
            dataIndex: 'task_num',
            key: 'task_num',
            ellipsis: false,
            align: 'center',
            width: 80,
          },
          {
            title: '任务名称',
            dataIndex: 'task_name',
            key: 'task_name',
            ellipsis: false,
            align: 'left',
            width: 150,
            render: (text, record, index) => (
              <div className={'task-name'} onClick={gotoCommitDetail}>
                {text}
              </div>
            ),
          },
          {
            title: '任务类型',
            dataIndex: 'task_type',
            key: 'task_type',
            ellipsis: false,
            align: 'center',
            width: 80,
          },
          {
            title: '项目',
            dataIndex: 'project_name',
            key: 'project_name',
            ellipsis: false,
            align: 'left',
            width: 100,
            filters: [
              {
                text: '个人信用风险评估项目',
                value: '个人信用风险评估项目',
              },
              {
                text: 'COVID-19疫情可视化分析与建模项目',
                value: 'COVID-19疫情可视化分析与建模项目',
              },
              {
                text: 'Spark大数据分析项目',
                value: 'Spark大数据分析项目',
              },
              {
                text: '电商数据分析项目',
                value: '电商数据分析项目',
              },
              {
                text: 'Python数据分析项目',
                value: 'Python数据分析项目',
              },
            ],
          },
          {
            title: '用户',
            dataIndex: 'user',
            key: 'user',
            ellipsis: false,
            align: 'center',
            width: 80,
          },
          {
            title: '角色',
            dataIndex: 'role',
            key: 'role',
            ellipsis: false,
            align: 'center',
            width: 50,
            render: (text: any, record: any, index: any) =>
              text == 0 ? '教师' : text == 1 ? '学生' : '',
          },
          {
            title: '院校',
            dataIndex: 'college',
            key: 'college',
            ellipsis: false,
            align: 'center',
            width: 100,
          },
          {
            title: '开始时间',
            dataIndex: 'start_time',
            key: 'start_time',
            ellipsis: false,
            align: 'center',
            width: 100,
            sorter: true,
            sortDirections: ['ascend', 'descend'],
          },
          {
            title: '结束时间',
            dataIndex: 'finish_time',
            key: 'finish_time',
            ellipsis: false,
            align: 'center',
            width: 100,
            sorter: true,
            sortDirections: ['ascend', 'descend'],
          },
          {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            ellipsis: false,
            align: 'left',
            width: 110,
            filters: [
              {
                text: '运行中',
                value: 'running',
              },
              {
                text: '成功',
                value: 'success',
              },
              {
                text: '失败',
                value: 'failed',
              },
              {
                text: '已停止',
                value: 'stoped',
              },
              {
                text: '排队中',
                value: 'queueing',
              },
            ],
            render: renderStatus,
          },
          // {
          //   title: '进度',
          //   dataIndex: 'process',
          //   key: 'process',
          //   ellipsis: false,
          //   align: 'center',
          //   width: 100,
          // },
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            ellipsis: false,
            align: 'center',
            width: 100,
            render: renderAction,
          },
        ]
      : mode === 'college-oam'
      ? [
          {
            title: '提交ID',
            dataIndex: 'commit_id',
            key: 'commit_id',
            align: 'center',
            width: 70,
          },
          {
            title: '任务ID',
            dataIndex: 'task_id',
            key: 'task_id',
            ellipsis: false,
            align: 'center',
            width: 70,
          },
          {
            title: '任务编号',
            dataIndex: 'task_num',
            key: 'task_num',
            ellipsis: false,
            align: 'center',
            width: 80,
          },
          {
            title: '任务名称',
            dataIndex: 'task_name',
            key: 'task_name',
            ellipsis: false,
            align: 'left',
            width: 150,
            render: (text, record, index) => (
              <div className={'task-name'} onClick={gotoCommitDetail}>
                {text}
              </div>
            ),
          },
          {
            title: '任务类型',
            dataIndex: 'task_type',
            key: 'task_type',
            ellipsis: false,
            align: 'center',
            width: 80,
          },
          {
            title: '项目',
            dataIndex: 'project_name',
            key: 'project_name',
            ellipsis: false,
            align: 'left',
            width: 100,
            filters: [
              {
                text: '个人信用风险评估项目',
                value: '个人信用风险评估项目',
              },
              {
                text: 'COVID-19疫情可视化分析与建模项目',
                value: 'COVID-19疫情可视化分析与建模项目',
              },
              {
                text: 'Spark大数据分析项目',
                value: 'Spark大数据分析项目',
              },
              {
                text: '电商数据分析项目',
                value: '电商数据分析项目',
              },
              {
                text: 'Python数据分析项目',
                value: 'Python数据分析项目',
              },
            ],
          },
          {
            title: '用户',
            dataIndex: 'user',
            key: 'user',
            ellipsis: false,
            align: 'center',
            width: 80,
          },
          {
            title: '角色',
            dataIndex: 'role',
            key: 'role',
            ellipsis: false,
            align: 'center',
            width: 50,
            render: (text: any, record: any, index: any) =>
              text == 0 ? '教师' : text == 1 ? '学生' : '',
          },
          {
            title: '开始时间',
            dataIndex: 'start_time',
            key: 'start_time',
            ellipsis: false,
            align: 'center',
            width: 100,
            sorter: true,
            sortDirections: ['ascend', 'descend'],
          },
          {
            title: '结束时间',
            dataIndex: 'finish_time',
            key: 'finish_time',
            ellipsis: false,
            align: 'center',
            width: 100,
            sorter: true,
            sortDirections: ['ascend', 'descend'],
          },
          {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            ellipsis: false,
            align: 'left',
            width: 110,
            filters: [
              {
                text: '运行中',
                value: 'running',
              },
              {
                text: '成功',
                value: 'success',
              },
              {
                text: '失败',
                value: 'failed',
              },
              {
                text: '已停止',
                value: 'stoped',
              },
              {
                text: '排队中',
                value: 'queueing',
              },
            ],
            render: renderStatus,
          },
          // {
          //   title: '进度',
          //   dataIndex: 'process',
          //   key: 'process',
          //   ellipsis: false,
          //   align: 'center',
          //   width: 100,
          // },
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            ellipsis: false,
            align: 'center',
            width: 100,
            render: renderAction,
          },
        ]
      : []

  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    // if (sorter.order) { //如果选择了排序列
    //   order.current = sorter.order;
    //   order_by.current = sorter.field;
    // }
    // if (filters.type) { //如果选择了过滤列
    //   typeFilters.current = filters.type;
    // } else {
    //   typeFilters.current = [];
    // }
    // if (filters.difficulty) {
    //   difficultyFilters.current = filters.difficulty;
    // } else {
    //   difficultyFilters.current = [];
    // }
    // page.current = 1;
    // queryExerciseList();
  }
  const onPageChange = (newPage: number, newPageSize: number) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
  }
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log(
      'selectedRowKeys changed: ',
      selectedRowKeys,
      newSelectedRowKeys
    )
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const searchByTaskNameAndId = (value: any) => {
    console.log(value)
  }

  const selectChange = (value: string) => {
    console.log(value)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.status !== 'running', // Column configuration not to be checked
    }),
  }

  const onStopTaskOk = () => {
    setTooltipopen(false)
  }

  return (
    <div style={{ margin: '0 auto' }}>
      <div className={commitStyle.cardContainer}>
        {statusCard.current.map((card, cardIndex) => {
          return (
            <StatusCard
              key={card.type}
              type={card.type}
              label={card.label}
              num={card.num}
              mode={'admin'}
            />
          )
        })}
      </div>
      <div
        className={projectStyles.tableWrapper}
        style={{
          width: 1140,
          height: 'calc(100vh - 150px)',
          backgroundColor: '#ffffff',
          borderRadius: 10,
          marginTop: 20,
          marginLeft: 20,
          overflow: 'auto',
        }}
      >
        <div
          className={projectStyles.classroomListHeader}
          style={{ paddingTop: 10 }}
        >
          <Row wrap={false} align="middle" style={{ marginTop: 0, height: 50 }}>
            <Col span={5} style={{ fontSize: 16, textAlign: 'left' }}>
              <Search
                style={{
                  width: 200,
                  marginRight: 10,
                  marginTop: 3,
                  marginLeft: 10,
                }}
                className={useStyle.searchInput}
                placeholder="请输入任务名称/编号"
                size="small"
                onSearch={searchByTaskNameAndId}
              />
            </Col>
            <Col span={4} style={{ position: 'relative' }}>
              <Select
                getPopupContainer={(trigger) => trigger.parentNode}
                // className={idataCodingStylesDark.selectInput}
                size="small"
                labelInValue
                defaultValue={'全部班级'}
                style={{ width: 150 }}
                onChange={selectChange}
              >
                {seleOptions.map((opt, optIndex) => {
                  return (
                    <Option key={optIndex} value={opt.value}>
                      {opt.label}
                    </Option>
                  )
                })}
              </Select>
            </Col>
            <Col span={8}>
              <DateRangePicker mode={'oam'} />
            </Col>
            <Col span={7} style={{ textAlign: 'right' }}>
              {/*<Button  disabled type='primary' style={{backgroundColor:"#666666"}}>批量停止</Button>*/}
              <Button
                disabled={selectedRowKeys.length > 1 ? false : true}
                type="primary"
                onClick={() => setOpen(true)}
                style={{ marginRight: 10 }}
              >
                批量停止
              </Button>
            </Col>
          </Row>
        </div>
        <ConfigProvider locale={zhCN}>
          <Table
            size={'small'}
            dataSource={commitData}
            columns={commitCols}
            rowKey={(record, index) => index!.toString()}
            pagination={{
              size: 'default',
              position: ['bottomCenter'],
              defaultPageSize: 10,
              pageSize: pageSize.current,
              current: page.current,
              defaultCurrent: 1,
              hideOnSinglePage: false,
              onChange: onPageChange,
            }}
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }}
            scroll={{ scrollToFirstRowOnChange: true, x: true }}
            //bordered={true}
            onChange={onTableChange}
            style={{ margin: 10 }}
          />
        </ConfigProvider>
      </div>
      <TooltipModal
        tooltipopen={tooltipopen}
        setTooltipopen={setTooltipopen}
        mode={'oam'}
        onOk={onStopTaskOk}
        content={<p>此任务正在运行中，确定要停止任务吗？</p>}
      />
      <BatchTooltipModal
        mode={'oam'}
        open={open}
        setOpen={setOpen}
        taskcount={selectedRowKeys.length}
      />
    </div>
  )
}

export default CommitRecord
